function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var CryptoModule = require('./../../../lib/templates/cryptomodule');
var WAValidator = require('@taasfi/multicoin-address-validator');
var Decimal = require('decimal.js');
var MixinModule = /*#__PURE__*/function (_CryptoModule) {
  function MixinModule(app, mixinMod, ticker, assetId, chainId) {
    var _this;
    _classCallCheck(this, MixinModule);
    _this = _callSuper(this, MixinModule, [app, ticker]);
    _this.mixin = mixinMod;
    _this.asset_id = assetId;
    _this.chain_id = chainId;
    _this.polling_active = 0;
    _this.polling_timeout = 0;
    _this.polling_intervals = [5000, 15000, 45000, 90000, 120000, 180000];
    _this.polling_interval_current = 0;
    _this.cached_contacts = [];
    _this.confirmations = 100;
    return _this;
  }
  _inherits(MixinModule, _CryptoModule);
  return _createClass(MixinModule, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, address, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              if (this.mixin.account_created) {
                _context.n = 2;
                break;
              }
              console.info('Create Mixin account');
              _context.n = 1;
              return this.mixin.createAccount();
            case 1:
              result = _context.v;
              if (!(result !== null && result !== void 0 && result.err || !this.mixin.account_created)) {
                _context.n = 2;
                break;
              }
              throw new Error((result === null || result === void 0 ? void 0 : result.err) || 'Mixin account was not created');
            case 2:
              if (this.address) {
                _context.n = 5;
                break;
              }
              console.info("Create Mixin deposit address -- ".concat(this.ticker));
              _context.n = 3;
              return this.mixin.accounts.createAddress(this.asset_id, this.chain_id);
            case 3:
              address = _context.v;
              if (address) {
                _context.n = 4;
                break;
              }
              throw new Error('Mixin deposit address was not created');
            case 4:
              this.address = address;
              this.save();
              console.info("Address for ".concat(this.ticker, ": ").concat(this.address));
            case 5:
              _context.n = 6;
              return _superPropGet(MixinModule, "activate", this, 3)([]);
            case 6:
              return _context.a(2, true);
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error("Unable to activate ".concat(this.ticker, ":"), _t);
              if (this.app.BROWSER) {
                salert("Having problem generating key for ".concat(this.ticker));
              }
              _context.n = 8;
              return this.app.wallet.setPreferredCrypto('SAITO');
            case 8:
              return _context.a(2, false);
          }
        }, _callee, this, [[0, 7]]);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "loadHistory",
    value: function () {
      var _loadHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(MixinModule, "loadHistory", this, 3)([]);
            case 1:
              _context2.n = 2;
              return this.fetchHistory();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadHistory() {
        return _loadHistory.apply(this, arguments);
      }
      return loadHistory;
    }()
  }, {
    key: "fetchBalance",
    value: function () {
      var _fetchBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ts, balance;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.address) {
                _context3.n = 1;
                break;
              }
              console.info('Mixin Error: no address - terminating fetch balance');
              return _context3.a(2);
            case 1:
              ts = Date.now();
              if (!(!this.last_balance_fetch || ts - this.last_balance_fetch > 10000)) {
                _context3.n = 3;
                break;
              }
              console.log('@@@ FetchBalance ' + this.ticker);
              this.last_balance_fetch = ts;
              _context3.n = 2;
              return this.mixin.api.fetchBalance(this.mixin.accounts.getCredentials(), this.asset_id);
            case 2:
              balance = _context3.v;
              if (balance !== false) {
                if (balance == this.pending_balance) {
                  delete this.pending_balance;
                }
                if (this.balance != balance) {
                  this.balance = balance;
                  this.save();
                }
              }
            case 3:
              return _context3.a(2, this.balance);
          }
        }, _callee3, this);
      }));
      function fetchBalance() {
        return _fetchBalance.apply(this, arguments);
      }
      return fetchBalance;
    }()
  }, {
    key: "getAvailableBalance",
    value: function () {
      var _getAvailableBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              return _context4.a(2, this.fetchBalance());
          }
        }, _callee4, this);
      }));
      function getAvailableBalance() {
        return _getAvailableBalance.apply(this, arguments);
      }
      return getAvailableBalance;
    }()
  }, {
    key: "getPendingBalance",
    value: function () {
      var _getPendingBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pendingBalance, _iterator, _step, deposit, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _t2 = Number;
              _context5.n = 1;
              return this.getAvailableBalance();
            case 1:
              pendingBalance = _t2(_context5.v);
              if (this.pending_balance) {
                if (pendingBalance !== this.pending_balance) {
                  pendingBalance = this.pending_balance;
                }
              }
              _context5.n = 2;
              return this.fetchPendingDeposits();
            case 2:
              this.pending_deposits = _context5.v;
              _iterator = _createForOfIteratorHelper(this.pending_deposits);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  deposit = _step.value;
                  if (deposit.state === 'pending' || Number(deposit.confirmations) < Number(this.confirmations)) {
                    pendingBalance += Number(deposit.amount || 0);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context5.a(2, pendingBalance.toString() || '0');
          }
        }, _callee5, this);
      }));
      function getPendingBalance() {
        return _getPendingBalance.apply(this, arguments);
      }
      return getPendingBalance;
    }()
  }, {
    key: "fetchPendingDeposits",
    value: function () {
      var _fetchPendingDeposits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var callback,
          deposits,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              callback = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
              if (this.address) {
                _context6.n = 1;
                break;
              }
              this.pending_deposits = [];
              if (callback) {
                callback([]);
              }
              return _context6.a(2, []);
            case 1:
              _context6.n = 2;
              return this.mixin.api.fetchDeposits(this.mixin.accounts.getCredentials(), this.asset_id, this.address);
            case 2:
              deposits = _context6.v;
              this.pending_deposits = deposits === false ? this.pending_deposits || [] : deposits || [];
              if (callback) {
                callback(this.pending_deposits);
              }
              return _context6.a(2, this.pending_deposits);
          }
        }, _callee6, this);
      }));
      function fetchPendingDeposits() {
        return _fetchPendingDeposits.apply(this, arguments);
      }
      return fetchPendingDeposits;
    }()
  }, {
    key: "getSaitoPublicKey",
    value: function getSaitoPublicKey(userId) {
      for (var publicKey in this.cached_contacts) {
        if (this.cached_contacts[publicKey].includes(userId)) {
          return publicKey;
        }
      }
      var _iterator2 = _createForOfIteratorHelper(this.app.keychain.returnKeys()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _key$crypto_addresses;
          var key = _step2.value;
          if (key !== null && key !== void 0 && (_key$crypto_addresses = key.crypto_addresses) !== null && _key$crypto_addresses !== void 0 && (_key$crypto_addresses = _key$crypto_addresses[this.ticker]) !== null && _key$crypto_addresses !== void 0 && _key$crypto_addresses.includes(userId)) {
            return key.publicKey;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }, {
    key: "validateHistory",
    value: function () {
      var _validateHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var i, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _superPropGet(MixinModule, "validateHistory", this, 3)([]);
            case 1:
              i = 0;
            case 2:
              if (!(i < this.history.length)) {
                _context7.n = 6;
                break;
              }
              if (!(this.history[i].counter_party.address && !this.history[i].counter_party.publicKey)) {
                _context7.n = 5;
                break;
              }
              if (!(this.history[i].counter_party.publicKey !== '')) {
                _context7.n = 5;
                break;
              }
              _t3 = this.getSaitoPublicKey(this.history[i].counter_party.address);
              if (_t3) {
                _context7.n = 4;
                break;
              }
              _context7.n = 3;
              return this.lookupPublicKey(this.history[i].counter_party.address);
            case 3:
              _t3 = _context7.v;
            case 4:
              this.history[i].counter_party.publicKey = _t3;
            case 5:
              i++;
              _context7.n = 2;
              break;
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function validateHistory() {
        return _validateHistory.apply(this, arguments);
      }
      return validateHistory;
    }()
  }, {
    key: "lookupPublicKey",
    value: function () {
      var _lookupPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(userId) {
        var row, address;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return this.mixin.fetchMixinUser({
                asset_id: this.asset_id,
                user_id: userId
              });
            case 1:
              row = _context8.v;
              if (row) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, '');
            case 2:
              address = row.address || '';
              if (row.user_id) {
                address += '|' + row.user_id + '|mixin';
              }
              if (row.publickey) {
                this.cached_contacts[row.publickey] = address;
                if (this.app.keychain.hasPublicKey(row.publickey)) {
                  this.app.keychain.addCryptoAddress(row.publickey, this.ticker, address);
                }
              }
              return _context8.a(2, row.publickey || '');
          }
        }, _callee8, this);
      }));
      function lookupPublicKey(_x) {
        return _lookupPublicKey.apply(this, arguments);
      }
      return lookupPublicKey;
    }()
  }, {
    key: "mixinUserId",
    value: function mixinUserId(address) {
      var parts = String(address || '').trim().split('|');
      if (parts.length >= 3 && parts[parts.length - 1].toLowerCase() === 'mixin') {
        return parts[parts.length - 2].toLowerCase() || null;
      }
      return null;
    }
  }, {
    key: "paymentsHaveSameSender",
    value: function paymentsHaveSameSender(expectedSender, actualSender) {
      if (_superPropGet(MixinModule, "paymentsHaveSameSender", this, 3)([expectedSender, actualSender])) {
        return true;
      }
      var expectedId = this.mixinUserId(expectedSender) || String(expectedSender || '').trim().toLowerCase();
      var actualId = this.mixinUserId(actualSender) || String(actualSender || '').trim().toLowerCase();
      return Boolean(expectedId && actualId && expectedId === actualId);
    }
  }, {
    key: "fetchHistory",
    value: function () {
      var _fetchHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var since,
          callback,
          cursor,
          snapshots,
          events,
          fetched,
          _iterator3,
          _step3,
          snap,
          entry,
          publicKey,
          _args9 = arguments,
          _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              since = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : null;
              callback = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
              if (this.isActivated()) {
                _context9.n = 1;
                break;
              }
              if (callback) {
                callback(this.history);
              }
              return _context9.a(2, []);
            case 1:
              console.log('@@@ fetchHistory -- ' + this.ticker);
              if (this.asset_id) {
                _context9.n = 2;
                break;
              }
              if (callback) {
                callback(this.history);
              }
              return _context9.a(2, []);
            case 2:
              cursor = since > 0 ? since : this.history_update_ts + 1;
              _context9.n = 3;
              return this.mixin.api.fetchHistory(this.mixin.accounts.getCredentials(), this.asset_id, cursor);
            case 3:
              snapshots = _context9.v;
              events = snapshots === false || snapshots == null ? [] : snapshots;
              if (events.length > 0) {
                delete this.last_balance_fetch;
                delete this.last_balance;
              }
              fetched = [];
              _iterator3 = _createForOfIteratorHelper(events);
              _context9.p = 4;
              _iterator3.s();
            case 5:
              if ((_step3 = _iterator3.n()).done) {
                _context9.n = 12;
                break;
              }
              snap = _step3.value;
              entry = {
                snapshot_id: snap.snapshot_id,
                counter_party: {
                  address: ''
                },
                timestamp: new Date(snap.created_at).getTime(),
                amount: Number(snap.amount),
                trans_hash: snap.transaction_hash || ''
              };
              if (!(entry.timestamp < this.history_update_ts)) {
                _context9.n = 6;
                break;
              }
              return _context9.a(3, 11);
            case 6:
              if (snap.deposit) {
                entry.type = 'receive';
                entry.counter_party.address = snap.deposit.sender || '';
              } else if (snap.withdrawal) {
                entry.type = 'send';
                entry.counter_party.address = snap.withdrawal.receiver || '';
              } else if (entry.amount > 0) {
                entry.type = 'receive';
              } else {
                entry.type = 'send';
              }
              if (!(snap !== null && snap !== void 0 && snap.opponent_id)) {
                _context9.n = 10;
                break;
              }
              publicKey = this.getSaitoPublicKey(snap.opponent_id);
              if (publicKey) {
                _context9.n = 8;
                break;
              }
              _context9.n = 7;
              return this.lookupPublicKey(snap.opponent_id);
            case 7:
              publicKey = _context9.v;
            case 8:
              if (publicKey) {
                entry.counter_party.publicKey = publicKey;
              }
              _context9.n = 9;
              return this.processAddress(snap.opponent_id, false);
            case 9:
              entry.counter_party.address = _context9.v;
            case 10:
              this.history.push(entry);
              fetched.push(entry);
              if (entry.type === 'receive') {
                this.app.connection.emit('on-payment-received', {
                  ticker: this.ticker || '',
                  amount: String(Math.abs(entry.amount)),
                  receiver: this.publicKey,
                  receiver_address: this.formatAddress() || '',
                  sender_address: (entry === null || entry === void 0 ? void 0 : entry.counter_party.address) || 'unknown',
                  sender: (entry === null || entry === void 0 ? void 0 : entry.counter_party.publicKey) || 'unknown',
                  timestamp: entry.timestamp,
                  transaction_signature: entry.trans_hash
                });
              } else if (entry.type === 'send') {
                this.app.connection.emit('on-payment-sent', {
                  ticker: this.ticker || '',
                  amount: String(Math.abs(entry.amount)),
                  receiver_address: (entry === null || entry === void 0 ? void 0 : entry.counter_party.address) || 'unknown',
                  receiver: (entry === null || entry === void 0 ? void 0 : entry.counter_party.publicKey) || 'unknown',
                  sender_address: this.formatAddress() || '',
                  sender: this.publicKey,
                  timestamp: entry.timestamp,
                  transaction_signature: entry.trans_hash
                });
              }
              this.history_update_ts = Math.max(this.history_update_ts, entry.timestamp);
            case 11:
              _context9.n = 5;
              break;
            case 12:
              _context9.n = 14;
              break;
            case 13:
              _context9.p = 13;
              _t4 = _context9.v;
              _iterator3.e(_t4);
            case 14:
              _context9.p = 14;
              _iterator3.f();
              return _context9.f(14);
            case 15:
              if (events.length > 0) {
                this.save();
              }
              if (callback) {
                callback(this.history);
              }
              return _context9.a(2, fetched);
          }
        }, _callee9, this, [[4, 13, 14, 15]]);
      }));
      function fetchHistory() {
        return _fetchHistory.apply(this, arguments);
      }
      return fetchHistory;
    }()
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.polling_active = 0;
      if (this.polling_timeout) {
        clearTimeout(this.polling_timeout);
        this.polling_timeout = null;
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this2 = this;
      if (this.polling_active) {
        if (this.polling_interval_current > 0) {
          this.polling_interval_current--;
        }
        return;
      }
      this.polling_active = 1;
      this.polling_interval_current = 0;
      var _poll = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
          var walletUpdates, stillWaiting, delay;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                if (_this2.polling_active) {
                  _context0.n = 1;
                  break;
                }
                return _context0.a(2);
              case 1:
                _context0.n = 2;
                return _this2.fetchHistory();
              case 2:
                walletUpdates = _context0.v;
                stillWaiting = Object.keys(_this2.transfers_inbound).length > 0;
                if (!((walletUpdates === null || walletUpdates === void 0 ? void 0 : walletUpdates.length) > 0 && !stillWaiting || _this2.polling_interval_current >= _this2.polling_intervals.length)) {
                  _context0.n = 3;
                  break;
                }
                _this2.stopPolling();
                return _context0.a(2);
              case 3:
                delay = _this2.polling_intervals[_this2.polling_interval_current];
                _this2.polling_interval_current++;
                _this2.polling_timeout = setTimeout(_poll, delay);
              case 4:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function poll() {
          return _ref.apply(this, arguments);
        };
      }();
      _poll();
    }
  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var amount,
          recipient,
          uniqueHash,
          memo,
          address,
          parts,
          credentials,
          sent,
          _args1 = arguments,
          _t5;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              amount = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : '';
              recipient = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : '';
              uniqueHash = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : '';
              memo = _args1.length > 3 && _args1[3] !== undefined ? _args1[3] : '';
              _context1.n = 1;
              return this.processAddress(recipient);
            case 1:
              address = _context1.v;
              if (address) {
                _context1.n = 2;
                break;
              }
              throw new Error("MixinModule: invalid address for ".concat(this.ticker, " -- ").concat(recipient));
            case 2:
              parts = address.split('|');
              credentials = this.mixin.accounts.getCredentials();
              _context1.p = 3;
              if (!(parts.length >= 3 && parts[2] === 'mixin')) {
                _context1.n = 5;
                break;
              }
              _context1.n = 4;
              return this.mixin.api.sendToUser(credentials, this.asset_id, parts[1], amount, memo);
            case 4:
              sent = _context1.v;
              _context1.n = 8;
              break;
            case 5:
              if (!this.validateAddress(address)) {
                _context1.n = 7;
                break;
              }
              _context1.n = 6;
              return this.mixin.api.sendToAddress(credentials, this.asset_id, address, amount, memo);
            case 6:
              sent = _context1.v;
              _context1.n = 8;
              break;
            case 7:
              throw new Error("invalid address for ".concat(this.ticker, " -- ").concat(address));
            case 8:
              _context1.n = 10;
              break;
            case 9:
              _context1.p = 9;
              _t5 = _context1.v;
              throw new Error('MixinModule: ' + (_t5 instanceof Error ? _t5.message : _t5 || 'payment failed'));
            case 10:
              if (Number.isFinite(sent.pendingBalance)) {
                this.pending_balance = sent.pendingBalance;
              } else if (this.balance != null && this.balance !== '') {
                this.pending_balance = Number(new Decimal(this.balance).minus(amount).toFixed(8));
              }
              if (!this.last_balance) {
                this.last_balance = this.balance;
              }
              return _context1.a(2, sent.hash || uniqueHash);
          }
        }, _callee1, this, [[3, 9]]);
      }));
      function sendPayment() {
        return _sendPayment.apply(this, arguments);
      }
      return sendPayment;
    }()
  }, {
    key: "formatAddress",
    value: function formatAddress() {
      var _this$mixin$credentia;
      var userId = ((_this$mixin$credentia = this.mixin.credentials) === null || _this$mixin$credentia === void 0 ? void 0 : _this$mixin$credentia.user_id) || this.mixin.accounts.getCredentials().user_id || '';
      return this.address + '|' + userId + '|' + 'mixin';
    }
  }, {
    key: "returnPrivateKey",
    value: function returnPrivateKey() {
      return this.mixin.accounts.getCredentials().spend_private_key;
    }
  }, {
    key: "returnMixinNetworkInfo",
    value: function () {
      var _returnMixinNetworkInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var info;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return this.mixin.api.fetchAsset(this.asset_id);
            case 1:
              info = _context10.v;
              if (info) {
                _context10.n = 2;
                break;
              }
              return _context10.a(2, false);
            case 2:
              this.confirmations = info.confirmations || 0;
              this.price_usd = Number(info.price_usd);
              this.last_update = Date.now();
              this.icon_url = info.icon_url;
              return _context10.a(2, info);
          }
        }, _callee10, this);
      }));
      function returnMixinNetworkInfo() {
        return _returnMixinNetworkInfo.apply(this, arguments);
      }
      return returnMixinNetworkInfo;
    }()
  }, {
    key: "checkWithdrawalFeeForAddress",
    value: function () {
      var _checkWithdrawalFeeForAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var address,
          callback,
          parts,
          fee,
          _this$mixin$crypto_mo,
          feeBalance,
          feeModule,
          _args11 = arguments;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              address = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : '';
              callback = _args11.length > 1 ? _args11[1] : undefined;
              if (!(address == '')) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2, callback(0));
            case 1:
              _context11.n = 2;
              return this.processAddress(address);
            case 2:
              address = _context11.v;
              parts = String(address || '').split('|');
              if (!(parts.length >= 3 && parts[2] === 'mixin')) {
                _context11.n = 3;
                break;
              }
              return _context11.a(2, callback(0));
            case 3:
              _context11.n = 4;
              return this.mixin.api.fetchWithdrawalFee(this.mixin.accounts.getCredentials(), this.asset_id, address);
            case 4:
              fee = _context11.v;
              if (!(fee !== false)) {
                _context11.n = 6;
                break;
              }
              _context11.n = 5;
              return this.mixin.api.fetchBalance(this.mixin.accounts.getCredentials(), fee.asset_id);
            case 5:
              feeBalance = _context11.v;
              feeModule = (_this$mixin$crypto_mo = this.mixin.crypto_mods) === null || _this$mixin$crypto_mo === void 0 ? void 0 : _this$mixin$crypto_mo.find(function (cryptoModule) {
                return cryptoModule.asset_id === fee.asset_id;
              });
              return _context11.a(2, callback(fee.amount, _objectSpread(_objectSpread({}, fee), {}, {
                ticker: (feeModule === null || feeModule === void 0 ? void 0 : feeModule.ticker) || fee.ticker,
                available_balance: feeBalance === false ? null : feeBalance
              })));
            case 6:
              return _context11.a(2, callback(0));
          }
        }, _callee11, this);
      }));
      function checkWithdrawalFeeForAddress() {
        return _checkWithdrawalFeeForAddress.apply(this, arguments);
      }
      return checkWithdrawalFeeForAddress;
    }()
  }, {
    key: "returnAddressFromPublicKey",
    value: function () {
      var _returnAddressFromPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(publicKey) {
        var key, row, address, _t6;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              if (!this.cached_contacts[publicKey]) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2, this.cached_contacts[publicKey]);
            case 1:
              key = this.app.keychain.returnKey(publicKey, true);
              if (!(key !== null && key !== void 0 && key.crypto_addresses)) {
                _context12.n = 2;
                break;
              }
              return _context12.a(2, key.crypto_addresses[this.ticker]);
            case 2:
              _context12.n = 3;
              return this.mixin.fetchMixinUser({
                publicKey: publicKey,
                asset_id: this.asset_id
              });
            case 3:
              row = _context12.v;
              if (!(!row || row.asset_id !== this.asset_id)) {
                _context12.n = 4;
                break;
              }
              return _context12.a(2, '');
            case 4:
              address = row.address;
              if (row.user_id) {
                address += '|' + row.user_id + '|mixin';
              }
              this.cached_contacts[publicKey] = address;
              if (this.app.keychain.hasPublicKey(publicKey)) {
                this.app.keychain.addCryptoAddress(publicKey, this.ticker, address);
              }
              return _context12.a(2, address);
            case 5:
              _context12.p = 5;
              _t6 = _context12.v;
              return _context12.a(2, null);
          }
        }, _callee12, this, [[0, 5]]);
      }));
      function returnAddressFromPublicKey(_x2) {
        return _returnAddressFromPublicKey.apply(this, arguments);
      }
      return returnAddressFromPublicKey;
    }()
  }, {
    key: "processAddress",
    value: function () {
      var _processAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(recipient) {
        var remoteFallback,
          address,
          publicKey,
          _iterator4,
          _step4,
          _key$crypto_addresses2,
          key,
          row,
          _args13 = arguments,
          _t7,
          _t8,
          _t9;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              remoteFallback = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : true;
              if (recipient) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2, recipient);
            case 1:
              address = String(recipient);
              if (!address.includes('|mixin')) {
                _context13.n = 2;
                break;
              }
              return _context13.a(2, address);
            case 2:
              if (!this.app.crypto.isPublicKey(address)) {
                _context13.n = 4;
                break;
              }
              _context13.n = 3;
              return this.returnAddressFromPublicKey(address);
            case 3:
              return _context13.a(2, _context13.v);
            case 4:
              _t7 = _regeneratorKeys(this.cached_contacts);
            case 5:
              if ((_t8 = _t7()).done) {
                _context13.n = 7;
                break;
              }
              publicKey = _t8.value;
              if (!this.cached_contacts[publicKey].includes(address)) {
                _context13.n = 6;
                break;
              }
              return _context13.a(2, this.cached_contacts[publicKey]);
            case 6:
              _context13.n = 5;
              break;
            case 7:
              _iterator4 = _createForOfIteratorHelper(this.app.keychain.returnKeys());
              _context13.p = 8;
              _iterator4.s();
            case 9:
              if ((_step4 = _iterator4.n()).done) {
                _context13.n = 11;
                break;
              }
              key = _step4.value;
              if (!(key !== null && key !== void 0 && (_key$crypto_addresses2 = key.crypto_addresses) !== null && _key$crypto_addresses2 !== void 0 && (_key$crypto_addresses2 = _key$crypto_addresses2[this.ticker]) !== null && _key$crypto_addresses2 !== void 0 && _key$crypto_addresses2.includes(address))) {
                _context13.n = 10;
                break;
              }
              return _context13.a(2, key.crypto_addresses[this.ticker]);
            case 10:
              _context13.n = 9;
              break;
            case 11:
              _context13.n = 13;
              break;
            case 12:
              _context13.p = 12;
              _t9 = _context13.v;
              _iterator4.e(_t9);
            case 13:
              _context13.p = 13;
              _iterator4.f();
              return _context13.f(13);
            case 14:
              if (!remoteFallback) {
                _context13.n = 16;
                break;
              }
              _context13.n = 15;
              return this.mixin.fetchMixinUser({
                address: address,
                asset_id: this.asset_id
              });
            case 15:
              row = _context13.v;
              if (row !== null && row !== void 0 && row.publickey && row.user_id) {
                address += '|' + row.user_id + '|mixin';
                this.cached_contacts[row.publickey] = address;
                if (this.app.keychain.hasPublicKey(row.publickey)) {
                  this.app.keychain.addCryptoAddress(row.publickey, this.ticker, address);
                }
              }
            case 16:
              return _context13.a(2, address);
          }
        }, _callee13, this, [[8, 12, 13, 14]]);
      }));
      function processAddress(_x3) {
        return _processAddress.apply(this, arguments);
      }
      return processAddress;
    }()
  }, {
    key: "validateAddress",
    value: function validateAddress(address) {
      var _this3 = this;
      if (String(address).includes('|')) {
        address = String(address).split('|')[0];
      }
      try {
        var _this$mixin;
        var chain = (_this$mixin = this.mixin) === null || _this$mixin === void 0 || (_this$mixin = _this$mixin.crypto_mods) === null || _this$mixin === void 0 ? void 0 : _this$mixin.find(function (cryptoModule) {
          return cryptoModule.asset_id === _this3.chain_id;
        });
        return WAValidator.validate(address, (chain === null || chain === void 0 ? void 0 : chain.ticker) || this.ticker);
      } catch (err) {
        console.error("Error 'validateAddress' MixinModule: ", err);
        return false;
      }
    }
  }]);
}(CryptoModule);
module.exports = MixinModule;